











import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import { 発注未確定重複レコード型 } from '@/type/purchaseorder/item';
import { 発注重複表示区分 } from '@/type/purchaseorder/types';
import NormalDialog from '@/components/atom/dialog/NormalDialog.vue';
import DuplicateWarningDialog from '@/views/purchaseorder/DuplicateWarningDialog.vue';

@Component({
  components: {
    NormalDialog,
    DuplicateWarningDialog,
  },
})

export default class OrderDuplicateDialog extends Vue {
  private 警告画面表示モード: string = 発注重複表示区分.発注確定送信;

@Prop({default: false})
  private modal!: boolean;

  @Prop({ default: []})
  private duplicateItemList!: 発注未確定重複レコード型[];

  private 重複ありで確定送信する() {
    this.$modal.hide('発注重複警告画面');
    this.$emit('confirm-duplicate-order');
  }

  private 戻る() {
    this.$modal.hide('発注重複警告画面');
    this.$emit('cancel-duplicate-order');
  }

  @Watch('modal')
  private ダイアログ表示状態変更(nowModal: boolean, prevModal: boolean) {
    if (nowModal === true) {
      this.$modal.show('発注重複警告画面');
    }
  }
}
